module.exports = __webpack_public_path__ + "img/win_item19.7a3ab52d.png";